import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/valuePatinetSatisfaction/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/valuePatinetSatisfaction/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/valuePatinetSatisfaction/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/valuePatinetSatisfaction/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/valuePatinetSatisfaction/update', params,options)

export const getPatinetSatisfaction = (params, options) =>
  request.post('/api/v4ward/valuePatinetSatisfaction/getPatinetSatisfaction', params,options)

// 供应商列表
export const getPartnerList = (params, options) =>
  request.get('/api/v4ward/partner/partnerlist', Object.assign({}, options, { params }));
